export default "__VITE_ASSET__5Ja8EyzW__"